export { default } from "./CardsList";



// WEBPACK FOOTER //
// ./src/components/emission/cards/CardsList/index.js